module.exports = __webpack_public_path__ + "static/media/PORTADA.9ea411b5.JPG";